export default __webpack_public_path__ + "static/media/VehicleRange_Green.a0106ebf.png";